import type { PropsWithChildren } from 'react'

import { Sentry } from '@analytics/sentry'
import { SENTRY_DSN } from '@constants'

import * as S from './styled'

const ErrorFallback = () => (
  <S.Wrapper>
    <S.IconWrapper>
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
          stroke="#DC2626"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </S.IconWrapper>
    <S.Title>Something went wrong</S.Title>
    <S.Description>
      An unexpected error occurred. Please reload the page or try again later.
    </S.Description>
    <S.ReloadButton onClick={() => window.location.reload()}>Reload page</S.ReloadButton>
  </S.Wrapper>
)

export const SentryProvider = ({ children }: PropsWithChildren) =>
  SENTRY_DSN ? (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>
  ) : (
    <>{children}</>
  )
